module.exports = __webpack_public_path__ + "img/outline-settings-24px.23a9c7b6.svg";